import React, { useEffect, useState } from 'react';

export default function IntroLoader() {
  const [phase, setPhase] = useState('spin'); // spin -> exit -> done
  const [visible, setVisible] = useState(() => typeof window !== 'undefined' && window.location.pathname === '/');

  useEffect(() => {
    if (!visible) return;
    // spin for 5s, then exit
    const t1 = setTimeout(() => setPhase('exit'), 5000);
    const t2 = setTimeout(() => setVisible(false), 5800);
    // lock scroll while intro is showing
    document.body.style.overflow = 'hidden';
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      document.body.style.overflow = '';
    };
  }, [visible]);

  useEffect(() => {
    if (!visible) document.body.style.overflow = '';
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      className={`fixed inset-0 z-[100] flex items-center justify-center bg-[#0F1C40] transition-opacity duration-700 ${
        phase === 'exit' ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
    >
      {/* subtle grid */}
      <div
        className="absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage:
            'linear-gradient(rgba(78,205,196,1) 1px, transparent 1px), linear-gradient(90deg, rgba(78,205,196,1) 1px, transparent 1px)',
          backgroundSize: '40px 40px',
        }}
      />

      {/* rotating E composition */}
      <div className="relative w-[160px] h-[160px] flex items-center justify-center">
        {/* outer rotating ring */}
        <svg viewBox="0 0 300 300" className="absolute inset-0 w-full h-full intro-spin-slow">
          <circle cx="150" cy="150" r="140" fill="none" stroke="rgba(78,205,196,0.15)" strokeWidth="1" strokeDasharray="4 8" />
          <circle cx="150" cy="150" r="140" fill="none" stroke="#4ECDC4" strokeWidth="1.5" strokeDasharray="8 800" />
        </svg>

        {/* inner counter-rotating ring */}
        <svg viewBox="0 0 300 300" className="absolute inset-4 w-[calc(100%-32px)] h-[calc(100%-32px)] intro-spin-rev">
          <circle cx="150" cy="150" r="120" fill="none" stroke="rgba(78,205,196,0.25)" strokeWidth="1" />
          <circle cx="150" cy="150" r="120" fill="none" stroke="#4ECDC4" strokeWidth="2" strokeDasharray="20 800" />
        </svg>

        {/* spark decoration rotating */}
        <svg viewBox="0 0 200 200" className="absolute -top-3 -right-3 w-9 h-9 intro-spin-slow opacity-70">
          <path d="M100 0 L110 90 L200 100 L110 110 L100 200 L90 110 L0 100 L90 90 Z" fill="#4ECDC4" />
        </svg>

        {/* Rotating multi-color E (Google-style) */}
        <div className="relative flex items-center justify-center">
          <span
            className="font-serif italic intro-e-rotate intro-e-google select-none"
            style={{ fontSize: '96px', lineHeight: 1, display: 'inline-block' }}
          >
            e
          </span>
        </div>
      </div>

      {/* label */}
      <div
        className="absolute bottom-16 left-1/2 -translate-x-1/2 text-center"
        style={{ opacity: phase === 'exit' ? 0 : 1, transition: 'opacity 400ms' }}
      >
        <div className="flex items-center justify-center gap-2 text-[10px] font-mono uppercase tracking-[0.3em] text-white/60 mb-2">
          <span className="w-2 h-2 rounded-full bg-[#4ECDC4] pulse-dot" />
          <span>Loading Innovation</span>
        </div>
        <div className="text-[#F1EDE4] text-lg font-semibold tracking-tight">EvolveBPM</div>
      </div>

      {/* progress bar */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 w-40 h-px bg-white/10 overflow-hidden">
        <div className="h-full bg-[#4ECDC4] intro-progress" />
      </div>
    </div>
  );
}
